import {
  LATENCY_SOURCE,
  LatencySample,
  LatencySource,
} from '../../../services/networkLatencyObserver';
import {
  NetworkQualityContext,
  NetworkStatus,
} from '../NetworkStatusProvider.types';

interface PrepareNetworkStatusTraceContextArgs {
  networkStatus: NetworkStatus;
  networkContext: NetworkQualityContext;
  requestSamples: LatencySample[];
  networkSamples: LatencySample[];
}

export interface NetworkStatusTraceRequest {
  path?: string;
  durationMs: number;
  networkLatencyMs?: number;
  isTimeout: boolean;
  latencySource: LatencySource;
}

export interface NetworkStatusTraceContext extends NetworkQualityContext {
  networkStatus: NetworkStatus;
  requests: NetworkStatusTraceRequest[];
}

const MASKED_PATH_SEGMENT = ':param';

const MAX_STATIC_PATH_SEGMENT_LENGTH = 40;

const STATIC_PATH_SEGMENT_PATTERN = /^[A-Za-z]+(?:[-_][A-Za-z]+)*$/;

const maskPathSegment = (segment: string): string =>
  segment === '' ||
  (segment.length <= MAX_STATIC_PATH_SEGMENT_LENGTH &&
    STATIC_PATH_SEGMENT_PATTERN.test(segment))
    ? segment
    : MASKED_PATH_SEGMENT;

function getMaskedUrlPath(url?: string): string | undefined {
  if (url === undefined) {
    return undefined;
  }

  try {
    return new URL(url, window.location.origin).pathname
      .split('/')
      .map(maskPathSegment)
      .join('/');
  } catch {
    return undefined;
  }
}

const adaptSampleToTraceRequest = (
  sample: LatencySample,
): NetworkStatusTraceRequest => ({
  path: getMaskedUrlPath(sample.url),
  durationMs: sample.durationMs,
  networkLatencyMs: sample.networkLatencyMs,
  isTimeout: sample.isTimeout,
  latencySource: sample.latencySource ?? LATENCY_SOURCE.REQUEST,
});

export const prepareNetworkStatusTraceContext = ({
  networkStatus,
  networkContext,
  requestSamples,
  networkSamples,
}: PrepareNetworkStatusTraceContextArgs): NetworkStatusTraceContext => ({
  ...networkContext,
  networkStatus,
  requests: [...requestSamples, ...networkSamples].map(
    adaptSampleToTraceRequest,
  ),
});
